import React, { use, useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  LinearProgress,
  Button,
  CircularProgress,
} from "@mui/material";
import { Code, Extension, ChangeHistory } from "@mui/icons-material";
import DashboardLayout from "../components/DashboardLayout";
import { dashboardPalette } from "../theme";
import avatarImage from "../assets/spr_placeholder_avatar.png";
import mascotImage from "../assets/dashboardMascot.png";
import NewsCarousel from "../components/NewsCarousel";
import useCurrentUserData from "../hooks/useCurrentUserData";
import useNewsData from "../hooks/useNewsData";
import RewardedProfileDisplay from "../components/RewardedProfileDisplay";
import { useAuth } from "../contexts/AuthContext";
import { UpdateEntryLevels } from "../firebase-config";
import teamImage from "../assets/team.png";


const Dashboard: React.FC = () => {
  const { userData } = useCurrentUserData();
  const { newsData } = useNewsData();
  const { user } = useAuth();
  const userSkills = userData?.Skill ?? [];
  const [equippedImage, setEquippedImage] = useState(String);

  const raw = localStorage.getItem(user!.uid)
  const parsed = JSON.parse(raw!);
  //funcion improvisada para inicializar la Imagen recompensa actual


  useEffect(() => {
    if (user) {
      SetLevel()
      setEquippedImage(getCurrentImageReward())
    }
  }, [user])

  async function SetLevel() {
    const check = CheckCurrentExp();
    await UpdateEntryLevels(user?.uid!, check!)
  }
  function getCurrentImageReward() {
    for (let i = 0; parsed?.Recompensas?.length > i; i++) {
      if (parsed?.Recompensas[i]?.Equipped === true) {
        return parsed?.Recompensas[i]?.Image
      }
    }
  }
  function CheckCurrentExp() {
    if (parsed?.CurrentExp! >= 0 && parsed?.CurrentExp! < 100) {
      return 1
    }
    if (parsed?.CurrentExp! >= 100 && parsed?.CurrentExp! < 250) {
      return 2
    }
    if (parsed?.CurrentExp! >= 250 && parsed?.CurrentExp! < 500) {
      return 3
    }
    if (parsed?.CurrentExp! >= 500 && parsed?.CurrentExp! < 900) {
      return 4
    }
    if (parsed?.CurrentExp! >= 900 && parsed?.CurrentExp! < 1500) {
      return 5
    }
    if (parsed?.CurrentExp! >= 1500 && parsed?.CurrentExp! < 2400) {
      return 6
    }
    if (parsed?.CurrentExp! >= 2400 && parsed?.CurrentExp! < 3600) {
      return 7
    }
    if (parsed?.CurrentExp! >= 3600 && parsed?.CurrentExp! < 5200) {
      return 8
    }
    if (parsed?.CurrentExp! >= 5200 && parsed?.CurrentExp! < 7500) {
      return 9
    }
    if (parsed?.CurrentExp! >= 7500 && parsed?.CurrentExp! < 10500) {
      return 10
    }
    if (parsed?.CurrentExp! >= 10500 && parsed?.CurrentExp! < 14500) {
      return 11
    }
    if (parsed?.CurrentExp! >= 14500 && parsed?.CurrentExp! < 17000) {
      return 12
    }
    if (parsed?.CurrentExp! >= 17000 && parsed?.CurrentExp! < 18500) {
      return 13
    }
    if (parsed?.CurrentExp! >= 18500 && parsed?.CurrentExp! < 19200) {
      return 14
    }
    if (parsed?.CurrentExp! >= 19200 && parsed?.CurrentExp! < 19800) {
      return 15
    }
    if (parsed?.CurrentExp! >= 19800 && parsed?.CurrentExp! < 20000) {
      return 16
    }
    if (parsed?.CurrentExp! >= 20000 && parsed?.CurrentExp! < 28000) {
      return 17
    }
    if (parsed?.CurrentExp! >= 28000 && parsed?.CurrentExp! < 40000) {
      return 18
    }
    if (parsed?.CurrentExp! >= 40000) {
      return 19
    }
  }
  const currentExpCap = () => {
    switch (userData?.Nivel) {
      case 1:
        return 100
      case 2:
        return 250
      case 3:
        return 500
      case 4:
        return 900
      case 5:
        return 1500
      case 6:
        return 2400
      case 7:
        return 3600
      case 8:
        return 5200
      case 9:
        return 7500
      case 10:
        return 10500
      case 11:
        return 14500
      case 12:
        return 17000
      case 13:
        return 18500
      case 14:
        return 19200
      case 15:
        return 19800
      case 16:
        return 20000
      case 17:
        return 28000
      case 18:
        return 40000
    }
  }
  const maxExp = currentExpCap();
  const currentExpProgress = userData?.CurrentExp! / maxExp! * 100
  /** 
  const currentExpProgress = Math.min(
    100,
    Math.max(0, ((userData?.CurrentExp ?? 0) * 100) / 1000),
  );*/
  const news = [
    {
      id: 1,
      title: "WEBINAR DISEÑO DE PERSONAJE",
      subtitle: "Faltan 3 días para",
      description: "A través de zoom por la profe Lorena Lorenzo...",
      hasImage: false,
    },
    {
      id: 2,
      title: "Conoce al equipo detrás",
      subtitle: "Novedades",
      description:
        "Conoce a los profesores, equipo académico en el encuentro académico de fin de año.",
      hasImage: true,
    },
  ];
  const featuredNews = newsData[1] ?? newsData[0] ?? null;

  const skillIcons = [
    <Code key="code" sx={{ fontSize: 18 }} />,
    <Extension key="extension" sx={{ fontSize: 18 }} />,
    <ChangeHistory key="shape" sx={{ fontSize: 18 }} />,
  ];

  const primaryCard = {
    backgroundColor: "var(--dashboard-panel-bg)",
    border: `3px solid ${dashboardPalette.panelBorder}`,
    borderRadius: "18px",
    boxShadow: "0 5px 0 rgba(62, 80, 147, 0.45)",
  };

  const yellowButtonSx = {
    px: 3,
    py: 0.8,
    minWidth: 112,
    borderRadius: "14px",
    backgroundColor: "var(--dashboard-yellow)",
    border: `2px solid ${dashboardPalette.accentYellowDark}`,
    fontWeight: 800,
    boxShadow: "0 3px 0 rgba(211, 158, 0, 0.95)",
    "&:hover": {
      backgroundColor: "var(--dashboard-yellow)",
    },
  };

  const TOP_ROW_HEIGHT = 350;
  const BOTTOM_ROW_HEIGHT = 470;

  return (
    <DashboardLayout showNavbar={true}>
      <Box
        sx={{
          minHeight: "100%",
          p: { xs: 1.5, md: 2 },
          backgroundColor: "var(--dashboard-page-bg)",
        }}
      >
        <Box
          sx={{
            maxWidth: 1400,
            margin: "0 auto",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Card
                  sx={{
                    ...primaryCard,
                    height: { xs: "auto", md: TOP_ROW_HEIGHT },
                  }}
                >
                  <CardContent sx={{ p: 0 }}>
                    <Box
                      sx={{
                        px: 2.5,
                        py: 2,
                        borderBottom: `1px solid ${dashboardPalette.track}`,
                      }}
                    >
                      <Typography
                        className="outlined-title-underlined"
                        sx={{
                          fontWeight: 900,
                          fontSize: "2rem",
                          lineHeight: 1,
                        }}
                      >
                        Mis Skills
                      </Typography>
                    </Box>

                    <Box sx={{ px: 2, py: 1.5 }}>
                      <>
                        {userSkills.map((skill, index) => {
                          return (
                            <div key={index}>
                              <Box
                                sx={{
                                  display: "grid",
                                  gridTemplateColumns: "34px 1fr auto",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    bgcolor: "#1f9ddd",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {skillIcons[index] || skillIcons[0]}
                                </Box>
                                <Typography
                                  sx={{
                                    color: "var(--dashboard-text)",
                                    fontWeight: 700,
                                    fontSize: "1.05rem",
                                  }}
                                >
                                  {skill.Materia}
                                </Typography>
                                <Typography
                                  sx={{
                                    color: "var(--dashboard-text)",
                                    fontWeight: 800,
                                  }}
                                >
                                  {skill.Progress}%
                                </Typography>
                              </Box>
                              <LinearProgress
                                variant="determinate"
                                value={skill.Progress}
                                sx={{
                                  mt: 0.6,
                                  ml: "42px",
                                  height: 14,
                                  borderRadius: 8,
                                  backgroundColor: "var(--dashboard-track)",
                                  "& .MuiLinearProgress-bar": {
                                    borderRadius: 8,
                                    backgroundColor: "var(--dashboard-teal)",
                                  },
                                }}
                              />
                            </div>
                          );
                        })}
                      </>
                    </Box>
                  </CardContent>
                </Card>

                <Card
                  sx={{
                    ...primaryCard,
                    overflow: "hidden",
                    height: { xs: "auto", md: BOTTOM_ROW_HEIGHT },
                  }}
                >
                  <CardContent
                    sx={{
                      p: 0,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        height: 350,
                        m: 1,
                        borderRadius: "10px",
                        background:
                          "linear-gradient(180deg, #6e63f0 0%, #ce77ef 100%)",
                        border: `2px solid ${dashboardPalette.white}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <RewardedProfileDisplay
                        src={userData?.PortraitImg}
                        alt="Perfil"
                        fallbackSrc={avatarImage}
                        width={300}
                        height={300}
                        border={`4px solid ${dashboardPalette.headerBlue}`}
                        boxShadow="0 4px 0 rgba(47,43,116,0.25)"
                        backgroundColor="#fff4c4"
                        rewards={"rewardDisplayData"}
                        badgeSize={28}
                        overlaySize={36}
                      />
                      {equippedImage ?
                        <Box
                          sx={{
                            position: "absolute"
                          }}>
                          <Box
                            component="img"
                            src={equippedImage}
                            sx={{
                              width: 300,
                              height: 300,
                              position: "relative",
                              top: -40,
                              left: 5
                            }}
                          />
                        </Box> : <></>}
                    </Box>

                    <Box
                      sx={{
                        px: 2,
                        pb: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography
                          className="outlined-title-underlined"
                          sx={{ fontWeight: 900, fontSize: "2rem" }}
                        >
                          {userData && userData.Nombre !== undefined ? (
                            <>{userData.Nombre}</>
                          ) : (
                            <>Loading...</>
                          )}
                        </Typography>
                        <Typography
                          sx={{
                            color: "var(--dashboard-text)",
                            fontSize: "1.4rem",
                          }}
                        >
                          {userData && userData.Nivel !== undefined ? (
                            <>Nivel {userData.Nivel}</>
                          ) : (
                            <>Nivel 0</>
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  height: { xs: "auto", md: TOP_ROW_HEIGHT },
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "var(--dashboard-yellow)",
                    border: `3px solid ${dashboardPalette.accentYellowDark}`,
                    borderRadius: "16px",
                    height: 58,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 0 rgba(211, 158, 0, 0.85)",
                  }}
                >
                  <Typography
                    className="outlined-title-underlined"
                    sx={{
                      fontWeight: 900,
                      fontSize: "2rem",
                    }}
                  >
                    Noticias
                  </Typography>
                </Box>

                <Card
                  sx={{
                    ...primaryCard,
                    flex: 1,
                    overflow: "hidden",
                  }}
                >
                  <NewsCarousel></NewsCarousel>
                </Card>
              </Box>

              <Card
                sx={{
                  ...primaryCard,
                  overflow: "hidden",
                  height: { xs: "auto", md: BOTTOM_ROW_HEIGHT },
                }}
              >
                <Box
                  sx={{
                    height: 290,
                    background:
                      "linear-gradient(180deg, #99addc 0%, #879ccb 100%)",
                    borderBottom: `2px solid ${dashboardPalette.panelBorder}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    component="img"
                    src={teamImage}
                    alt="Equipo"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>

                <CardContent sx={{ p: 2 }}>
                  <Typography
                    sx={{
                      color: "var(--dashboard-text)",
                      fontWeight: 900,
                      mb: 0.8,
                      fontSize: "1.85rem",
                      lineHeight: 1.15,
                    }}
                  >
                    {news[1].title}
                  </Typography>
                  <Typography
                    sx={{
                      color: "var(--dashboard-text)",
                      mb: 1.2,
                      fontSize: "1.05rem",
                      lineHeight: 1.35,
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {news[1].description}
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button sx={yellowButtonSx}>
                      <Box component="span" className="outlined-button-text">
                        Leer más
                      </Box>
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={3}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Card
                  sx={{
                    ...primaryCard,
                    overflow: "hidden",
                    height: { xs: "auto", md: TOP_ROW_HEIGHT },
                  }}
                >
                  <CardContent sx={{ p: 0 }}>
                    <Box
                      sx={{
                        px: 2.5,
                        py: 2,
                        borderBottom: `1px solid ${dashboardPalette.track}`,
                      }}
                    >
                      <Typography
                        className="outlined-title-underlined"
                        sx={{
                          fontWeight: 900,
                          fontSize: "2rem",
                        }}
                      >
                        Progreso
                      </Typography>
                    </Box>

                    <Box
                      sx={{ display: "flex", justifyContent: "center", py: 2 }}
                    >
                      <Box
                        sx={{ position: "relative", display: "inline-flex" }}
                      >
                        {userData && userData.CurrentExp !== undefined ? (
                          <>
                            <CircularProgress
                              variant="determinate"
                              value={100}
                              size={150}
                              thickness={4}
                              sx={{
                                color: "var(--dashboard-track)",
                                position: "absolute",
                                left: 0,
                              }}
                            />
                            <CircularProgress
                              variant="determinate"
                              value={currentExpProgress}
                              size={150}
                              thickness={4}
                              sx={{ color: "var(--dashboard-teal)" }}
                            />
                            <Box
                              sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "#7f96e6",
                                  fontWeight: 900,
                                  fontSize: "3.2rem",
                                  lineHeight: 1,
                                }}
                              >
                                {Math.round(currentExpProgress)}
                                <Typography
                                  component="span"
                                  sx={{ fontWeight: 800, fontSize: "1.8rem" }}
                                >
                                  %
                                </Typography>
                              </Typography>
                            </Box>
                          </>
                        ) : (
                          <>
                            <>
                              <CircularProgress
                                variant="determinate"
                                value={100}
                                size={150}
                                thickness={4}
                                sx={{
                                  color: "var(--dashboard-track)",
                                  position: "absolute",
                                  left: 0,
                                }}
                              />
                              <CircularProgress
                                variant="determinate"
                                value={0}
                                size={150}
                                thickness={4}
                                sx={{ color: "var(--dashboard-teal)" }}
                              />
                              <Box
                                sx={{
                                  top: 0,
                                  left: 0,
                                  bottom: 0,
                                  right: 0,
                                  position: "absolute",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: "#7f96e6",
                                    fontWeight: 900,
                                    fontSize: "3.2rem",
                                    lineHeight: 1,
                                  }}
                                >
                                  {0}
                                  <Typography
                                    component="span"
                                    sx={{ fontWeight: 800, fontSize: "1.8rem" }}
                                  >
                                    %
                                  </Typography>
                                </Typography>
                              </Box>
                            </>
                          </>
                        )}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        bgcolor: "var(--dashboard-section-blue)",
                        py: 1.3,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        className="outlined-title-underlined"
                        sx={{
                          fontWeight: 900,
                          fontSize: "2rem",
                        }}
                      >
                        {userData && userData.Nivel !== undefined ? (
                          <>Nivel {userData.Nivel}</>
                        ) : (
                          <>Nivel 0</>
                        )}
                      </Typography>
                    </Box>

                    <Box
                      sx={{ p: 2, display: "flex", justifyContent: "center" }}
                    >
                      <Button sx={yellowButtonSx}>
                        <Box component="span" className="outlined-button-text">
                          Ver más
                        </Box>
                      </Button>
                    </Box>
                  </CardContent>
                </Card>

                <Card
                  sx={{
                    ...primaryCard,
                    backgroundColor: "var(--dashboard-mascot-bg)",
                    height: { xs: "auto", md: BOTTOM_ROW_HEIGHT },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                  }}
                >
                  <Box
                    component="img"
                    src={mascotImage}
                    alt="Mascota"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Card>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Dashboard;
